import { useEffect } from 'react';
import Header from '@/components/layout/Header';
import ProjectTabs from '@/components/projects/ProjectTabs';

const Projects = () => {
  useEffect(() => {
    if (import.meta.env.DEV) {
      requestAnimationFrame(() => {
        try {
          performance.mark('nav:cleanup-end');
          performance.measure('nav:cleanup', 'nav:cleanup-start', 'nav:cleanup-end');
          const duration = performance.getEntriesByName('nav:cleanup').pop()?.duration;
          if (duration !== undefined) {
            console.debug('🚀 Navigation took:', Math.round(duration), 'ms');
            console.timeEnd('nav:click→projects-mounted');
          }
        } catch {
          // nav:cleanup-start mark may not exist if navigation didn't go through the expected path
        }
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container py-6">
        <ProjectTabs />
      </main>
    </div>
  );
};

export default Projects;
